import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { ProtectedRoute, PublicOnlyRoute } from '@/components/protected-route';
import { AuthLayout } from '@/layouts/auth-layout';
import { DashboardLayout } from '@/layouts/dashboard-layout';
import { ConfirmPage } from '@/pages/auth/confirm';
import { ForgotPasswordPage } from '@/pages/auth/forgot-password';
import { ResetPasswordPage } from '@/pages/auth/reset-password';
import { SignInPage } from '@/pages/auth/signin';
import { SignUpPage } from '@/pages/auth/signup';
import { NotFoundPage } from '@/pages/not-found';
import { OverviewPage } from '@/pages/overview';
import { OpportunitiesPage } from '@/pages/opportunities';
import { ProjectDataSourcesPage } from '@/pages/project-data-sources';
import { ProjectDetailsPage } from '@/pages/project-details';
import { NewProjectPage } from '@/pages/project-new';
import { ProjectsPage } from '@/pages/projects';
import { RealtimePage } from '@/pages/realtime';
import { SettingsPage } from '@/pages/settings';

const router = createBrowserRouter([
  ...(import.meta.env.DEV
    ? [
        {
          path: '/__preview/growth',
          lazy: () => import('@/pages/overview/growth-preview'),
        },
        {
          path: '/__preview/assistant',
          lazy: () => import('@/pages/assistant-preview'),
        },
      ]
    : []),
  {
    element: (
      <PublicOnlyRoute>
        <AuthLayout />
      </PublicOnlyRoute>
    ),
    children: [
      { path: '/signin', element: <SignInPage /> },
      { path: '/signup', element: <SignUpPage /> },
      { path: '/confirm', element: <ConfirmPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
    ],
  },
  {
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '/', element: <ProjectsPage /> },
      { path: '/projects/new', element: <NewProjectPage /> },
      { path: '/projects/:projectId/setup', element: <NewProjectPage /> },
      {
        path: '/projects/:projectId/reports',
        element: <OverviewPage detailed />,
      },
      { path: '/projects/:projectId', element: <OpportunitiesPage /> },
      { path: '/projects/:projectId/overview', element: <OverviewPage /> },
      {
        path: '/projects/:projectId/realtime',
        element: <RealtimePage />,
      },
      {
        path: '/projects/:projectId/data-sources',
        element: <ProjectDataSourcesPage />,
      },
      {
        path: '/projects/:projectId/details',
        element: <ProjectDetailsPage />,
      },
      { path: '/account', element: <SettingsPage /> },
      { path: '/settings', element: <Navigate to="/account" replace /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);

export const Router = () => <RouterProvider router={router} />;
